import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import type {
  TBulkUpdateInvoiceStatusRequest,
  TBulkUpdateInvoiceStatusResponse,
} from "./bulkUpdateInvoiceStatus.schema";

/**
 * Updates status for many invoices (by IDs or by filter). Used for bulk actions and "select all".
 * POST /api/invoices/bulk-update-status
 */
export const bulkUpdateInvoiceStatus =
  (axios: IAxiosInstance) =>
  async (
    params: TBulkUpdateInvoiceStatusRequest
  ): Promise<TBulkUpdateInvoiceStatusResponse> => {
    const response = await axios.noRetry.post(
      "/api/invoices/bulk-update-status",
      params
    );
    const resData = response.data;

    if (resData?.success && resData?.data != null) {
      return resData.data as TBulkUpdateInvoiceStatusResponse;
    }

    throw new Error(resData?.error || "Error bulk updating invoice status");
  };
